// extracted by mini-css-extract-plugin
module.exports = {"root":"DesignedQr_root__sDn80","plate":"DesignedQr_plate__4X_qi","fallback":"DesignedQr_fallback__nqaAC","host":"DesignedQr_host__ATMU3","caption":"DesignedQr_caption__9B4xw"};